import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import DropOffLocation from "./DropOffLocation";
import PickUpLocation from "./PickUpLocation";
import { Controller, useForm, useWatch } from "react-hook-form";
import LoadingButtonWithForm from "../../components/LoadingButtonWithForm";
import {
  useAddJobMutation,
  useEditJobMutation,
} from "../../redux/services/JobService";
import {
  convertToFormDataDeep,
  convertToFormDataDeepCopy,
  sweetAlert,
} from "../../utils";
import { responseError } from "../../helpers/responseHandler";
import { useGetSelectDriversQuery } from "../../redux/services/DriverService";
import { useGetSelectBrokersQuery } from "../../redux/services/BrokerService";
import { useGetSelectFactoryCompanyQuery } from "../../redux/services/FactoryCompanyService";
import moment from "moment";
import PhoneInput from "react-phone-input-2";

const AddCompanyModal = ({ show, handleClose, isEdit }) => {
  let {
    control,
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm();
  const bodyRef = useRef();
  const [showAdditionalPick, setShowAdditionalPick] = useState(false);
  const [showAdditionalDrop, setShowAdditionalDrop] = useState(false);
  const [addRequest, { isLoading: addLoading }] = useAddJobMutation();
  const [editRequest, { isLoading: editLoading }] = useEditJobMutation();

  const { data: data2 } = useGetSelectDriversQuery();
  const drivers = data2?.response?.data;
  const { data: data3 } = useGetSelectBrokersQuery();
  const brokers = data3?.response?.data;
  const { data: data4 } = useGetSelectFactoryCompanyQuery();
  const factoryCompany = data4?.response?.data;

  const [pickupdoc, setPickupdoc] = useState([
    { type: "", document_name: "", attachment: null },
  ]);
  const [dropoffdoc, setDropoffdoc] = useState([
    { type: "", document_name: "", attachment: null },
  ]);
  const [deletedTripDocs, setDeletedTripDocs] = useState([]);

  const addPickUpRow = () => {
    setPickupdoc([
      ...pickupdoc,
      { type: "PICKUP", document_name: "other", attachment: null },
    ]);
  };
  const removePickUpRow = (row) => {
    const filterItem = pickupdoc?.filter((doc) => doc != row);
    const filterItemList = pickupdoc
      ?.filter((doc) => doc == row)
      ?.map((item) => item?.id);
    setPickupdoc(filterItem);
    setValue("pickupdoc", filterItem);
    setDeletedTripDocs((pre) => [...pre, ...filterItemList]);
  };
  const addDropOffRow = () => {
    setDropoffdoc([
      ...dropoffdoc,
      { type: "PICKUP", document_name: "other", attachment: null },
    ]);
  };
  const removeDropOffRow = (row) => {
    const filterItem = dropoffdoc.filter((doc) => doc !== row);
    const filterItemList = dropoffdoc
      ?.filter((doc) => doc == row)
      ?.map((item) => item?.id);
    console.log("filterItemList", filterItemList);
    setDropoffdoc(filterItem);
    setValue("dropoffdoc", filterItem);
    setDeletedTripDocs((pre) => [...pre, ...filterItemList]);
  };

  const onSubmit = async (data) => {
    data["new_module"] = "yes";
    data["pickup_place_name"] = "hy";
    data["drop_place_name"] = "bro";
    data["job_start_datetime"] = moment(data?.job_start_datetime).format(
      "YYYY-MM-DD H:mm:ss"
    );
    data["drop_datetime"] = moment(data?.drop_datetime).format(
      "YYYY-MM-DD H:mm:ss"
    );
    data["show_original_document"] = data?.show_original_document
      ? data?.show_original_document
      : 0;
    data["show_rate_to_driver"] = data?.show_rate_to_driver
      ? data?.show_rate_to_driver
      : 0;
    data["deleted_trip_docs"] =
      deletedTripDocs?.length > 0 ? deletedTripDocs : [];

    // let pickups = pickupdoc?.length > 0 ? data?.pickupdoc?.map((doc) => {
    //     return {
    //         ...doc, id: doc?.id ?? 0,
    //     }
    // }) : []
    // let dropoffs = dropoffdoc?.length > 0 ? data?.dropoffdoc?.map((doc) => {
    //     return {
    //         ...doc, id: doc?.id ?? 0
    //     }
    // }) : []
    // data['trip_documents'] = [...pickups, ...dropoffs]
    data["trip_documents"] = [];
    // delete data.pickupdoc
    // delete data.dropoffdoc
    // console.log(data);

    if (isEdit) {
      const newForm = convertToFormDataDeepCopy({ ...data });

      await editRequest({ id: isEdit?.id, newForm })
        .unwrap()
        .then((res) => {
          if (res?.status) {
            sweetAlert(res?.message, "success");
            // navigate(-1)
            handleClose();
          }
        })
        .catch((err) => {
          responseError(err);
        });
    } else {
      const newForm = convertToFormDataDeepCopy({ ...data });

      await addRequest(newForm)
        .unwrap()
        .then((res) => {
          if (res?.status) {
            sweetAlert(res?.message, "success");
            // navigate(-1)
            handleClose();
          }
        })
        .catch((err) => {
          responseError(err);
        });
    }
  };

  useEffect(() => {
    if (isEdit) {
      const pickDoc = isEdit?.job_trip_documents?.filter(
        (doc) => doc.type === "PICKUP"
      );
      const dropDoc = isEdit?.job_trip_documents?.filter(
        (doc) => doc.type === "DROPOFF"
      );
      setPickupdoc([...pickDoc]);
      setDropoffdoc([...dropDoc]);
      pickDoc?.forEach((doc, index) => {
        setValue(`pickupdoc[${index}].id`, doc?.id);
        setValue(`pickupdoc[${index}].type2`, doc?.document_name);
        setValue(`pickupdoc[${index}].type`, "PICKUP");
        setValue(`pickupdoc[${index}].document_name`, doc?.document_name);
      });
      dropDoc?.forEach((doc, index) => {
        setValue(`dropoffdoc[${index}].id`, doc?.id);
        setValue(`dropoffdoc[${index}].type2`, doc?.document_name);
        setValue(`dropoffdoc[${index}].type`, "DROPOFF");
        setValue(`dropoffdoc[${index}].document_name`, doc?.document_name);
      });
      setValue("pickup_place_id", isEdit?.pickup_place_id);
      setValue("pickup_address", isEdit?.pickup_address);
      setValue("pickup_latitude", isEdit?.pickup_latitude);
      setValue("pickup_longitude", isEdit?.pickup_longitude);

      setValue("drop_place_id", isEdit?.drop_place_id);
      setValue("drop_address", isEdit?.drop_address);
      setValue("drop_latitude", isEdit?.drop_latitude);
      setValue("drop_longitude", isEdit?.drop_longitude);
    }
  }, [isEdit]);

  useEffect(() => {
    if (isEdit && drivers) {
      console.log("isEdit&drivers", isEdit, drivers);
      setValue(
        "driver_email",
        drivers?.find((driver) => driver?.id == isEdit?.driver_id)?.email
      );
      setValue(
        "driver_phone",
        drivers?.find((driver) => driver?.id == isEdit?.driver_id)?.phone
      );
      setValue(
        "broker_email",
        brokers?.find((driver) => driver?.id == isEdit?.broker_companies_id)
          ?.broker_email
      );
      setValue(
        "broker_phone",
        brokers?.find((driver) => driver?.id == isEdit?.broker_companies_id)
          ?.phone_number
      );
      setValue(
        "factoring_company_email",
        factoryCompany?.find(
          (driver) => driver?.id == isEdit?.factoring_companies_id
        )?.email
      );
      setValue(
        "factoring_company_phone",
        factoryCompany?.find(
          (driver) => driver?.id == isEdit?.factoring_companies_id
        )?.phone
      );
    }
  }, [drivers, factoryCompany, brokers, isEdit]);

  useEffect(() => {
    if (bodyRef.current) {
      bodyRef.current.scrollTop = 0;
    }
  }, []);

  // Watch values for job amount and miles
  const jobAmount = useWatch({ control, name: "job_amount" });
  const estimatedMiles = useWatch({ control, name: "estimated_miles" });

  useEffect(() => {
    // When both values exist and miles > 0, update the calculated field
    if (jobAmount && estimatedMiles > 0) {
      const calculatedValue =
        parseFloat(jobAmount) / parseFloat(estimatedMiles);
      setValue("estimated_dollar_per_mile", calculatedValue.toFixed(2));
    } else {
      setValue("estimated_dollar_per_mile", "");
    }
  }, [jobAmount, estimatedMiles, control]);

  console.log("isEdit", isEdit);
  return (
    <>
      <Modal
        show={show}
        size="xl"
        onHide={handleClose}
        dialogClassName="modal-dialog-scrollable"
      >
        <Modal.Header className="" closeButton>
          <Modal.Title className="h5">
            {isEdit ? "Edit" : "Add"} Trip
          </Modal.Title>
        </Modal.Header>
        <Modal.Body ref={bodyRef}>
          <Form onSubmit={handleSubmit(onSubmit)} id="job-add-form">
            <div class="row align-items-center mb-2">
              <div class="col-auto">
                <h5 className="mb-0">Job Reference:</h5>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-0">
                  <Controller
                    name="job_title"
                    control={control}
                    defaultValue={isEdit?.job_title || ""}
                    rules={{
                      required: false,
                    }}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                        type="text"
                        placeholder="Job Title"
                        isInvalid={errors.job_title}
                      />
                    )}
                  />
                </Form.Group>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Driver <span className="text-danger">*</span>
                  </Form.Label>
                  <Controller
                    name="driver_id"
                    control={control}
                    defaultValue={isEdit?.driver_id || ""}
                    rules={{
                      required: true,
                    }}
                    render={({ field }) => (
                      <Form.Select
                        {...field}
                        onChange={(e) => {
                          field.onChange(e.target.value);
                          setValue(
                            "driver_email",
                            drivers?.find(
                              (driver) => driver?.id == e.target.value
                            )?.email
                          );
                          setValue(
                            "driver_phone",
                            drivers?.find(
                              (driver) => driver?.id == e.target.value
                            )?.phone
                          );
                        }}
                        isInvalid={errors.driver_id}
                      >
                        <option value="">Select Driver</option>
                        {drivers?.map((driver) => (
                          <>
                            <option value={driver?.id}>
                              {driver?.full_name}
                            </option>
                          </>
                        ))}
                        {/* Add more driver options as needed */}
                      </Form.Select>
                    )}
                  />
                </Form.Group>
              </div>
              {/*<div className="col-md-4">*/}
              {/*    <Form.Group className="mb-3">*/}
              {/*        <Form.Label>Broker:</Form.Label>*/}
              {/*        <Controller*/}
              {/*            name="broker_companies_id"*/}
              {/*            control={control}*/}
              {/*            defaultValue={isEdit?.broker_companies_id || ''}*/}
              {/*            rules={{*/}
              {/*                required: true*/}
              {/*            }}*/}
              {/*            render={({ field }) => (*/}
              {/*                <Form.Select*/}
              {/*                    {...field}*/}
              {/*                    onChange={(e) => {*/}
              {/*                        field.onChange(e.target.value);*/}
              {/*                        console.log('company', brokers?.find((driver) => driver?.id == e.target.value))*/}
              {/*                        setValue('broker_email', brokers?.find((driver) => driver?.id == e.target.value)?.broker_email)*/}
              {/*                        setValue('broker_phone', brokers?.find((driver) => driver?.id == e.target.value)?.phone_number)*/}
              {/*                    }}*/}
              {/*                    isInvalid={errors.broker_companies_id}*/}
              {/*                >*/}
              {/*                    <option value="">Select Broker</option>*/}
              {/*                    {brokers?.map((item) => (*/}
              {/*                        <>*/}
              {/*                            <option value={item?.id}>{item?.broker_name}</option>*/}
              {/*                        </>*/}
              {/*                    ))}*/}
              {/*                </Form.Select>*/}
              {/*            )}*/}
              {/*        />*/}

              {/*    </Form.Group>*/}
              {/*</div>*/}

              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>Diver Email:</Form.Label>
                  <Controller
                    name="driver_email"
                    control={control}
                    defaultValue={
                      drivers?.find((driver) => driver?.id == isEdit?.driver_id)
                        ?.email || ""
                    }
                    rules={{
                      required: false,
                    }}
                    render={({ field }) => (
                      <Form.Control {...field} type="email" disabled />
                    )}
                  />
                </Form.Group>
              </div>
              {/*<div className="col-md-4">*/}
              {/*    <Form.Group className="mb-3">*/}
              {/*        <Form.Label>Broker Email:</Form.Label>*/}
              {/*        <Controller*/}
              {/*            name="broker_email"*/}
              {/*            control={control}*/}
              {/*            defaultValue={isEdit?.broker_email || ''}*/}
              {/*            rules={{*/}
              {/*                required: false*/}
              {/*            }}*/}
              {/*            render={({ field }) => (*/}
              {/*                <Form.Control {...field} type="email" disabled />*/}
              {/*            )}*/}
              {/*        />*/}
              {/*    </Form.Group>*/}
              {/*</div>*/}

              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>Driver Phone:</Form.Label>
                  <Controller
                    name="driver_phone"
                    control={control}
                    defaultValue={isEdit?.driver_phone || ""}
                    rules={{
                      required: false,
                    }}
                    render={({ field }) => (
                      <Form.Control {...field} type="tel" disabled />
                    )}
                  />
                </Form.Group>
              </div>
              {/*<div className="col-md-4">*/}
              {/*    <Form.Group className="mb-3">*/}
              {/*        <Form.Label>Broker Phone:</Form.Label>*/}
              {/*        <Controller*/}
              {/*            name="broker_phone"*/}
              {/*            control={control}*/}
              {/*            defaultValue={isEdit?.broker_phone || ''}*/}
              {/*            rules={{*/}
              {/*                required: false*/}
              {/*            }}*/}
              {/*            render={({ field }) => (*/}
              {/*                <Form.Control {...field} type="tel" disabled />*/}
              {/*            )}*/}
              {/*        />*/}
              {/*    </Form.Group>*/}
              {/*</div>*/}
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Factoring Company <span className="text-danger">*</span>
                  </Form.Label>
                  <Controller
                    name="factoring_companies_id"
                    control={control}
                    defaultValue={isEdit?.factoring_companies_id || ""}
                    rules={{
                      required: true,
                    }}
                    render={({ field }) => (
                      <Form.Select
                        {...field}
                        onChange={(e) => {
                          field.onChange(e.target.value);
                          console.log(
                            "company",
                            factoryCompany?.find(
                              (driver) => driver?.id == e.target.value
                            )
                          );
                          setValue(
                            "factoring_company_email",
                            factoryCompany?.find(
                              (driver) => driver?.id == e.target.value
                            )?.email
                          );
                          setValue(
                            "factoring_company_phone",
                            factoryCompany?.find(
                              (driver) => driver?.id == e.target.value
                            )?.phone
                          );
                        }}
                        isInvalid={errors.factoring_companies_id}
                      >
                        <option value="">Select Company</option>
                        {factoryCompany?.map((item) => (
                          <>
                            <option value={item?.id}>
                              {item?.company_name}
                            </option>
                          </>
                        ))}
                      </Form.Select>
                    )}
                  />
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>Factoring Company Email:</Form.Label>
                  <Controller
                    name="factoring_company_email"
                    control={control}
                    defaultValue={isEdit?.factoring_company_email || ""}
                    rules={{
                      required: false,
                    }}
                    render={({ field }) => (
                      <Form.Control {...field} type="email" disabled />
                    )}
                  />
                </Form.Group>
              </div>

              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>Factoring Company Phone:</Form.Label>
                  <Controller
                    name="factoring_company_phone"
                    control={control}
                    defaultValue={isEdit?.factoring_company_phone || ""}
                    rules={{
                      required: false,
                    }}
                    render={({ field }) => (
                      <Form.Control {...field} type="email" disabled />
                    )}
                  />
                </Form.Group>
              </div>
            </div>
            <hr />

            <h5>Pick Up Details:</h5>

            <div className="row d-flex align-items-end">
              <div className="col-md-4">
                <Controller
                  name="pickup_address"
                  control={control}
                  defaultValue={isEdit?.pickup_address || ""}
                  rules={{
                    required: true,
                  }}
                  render={({ field }) => (
                    <PickUpLocation
                      onSave={(place) => {
                        setValue("pickup_place_id", place?.place_id);
                        setValue("pickup_address", place?.formatted_address);
                        setValue(
                          "pickup_latitude",
                          place?.geometry?.location?.lat()
                        );
                        setValue(
                          "pickup_longitude",
                          place?.geometry?.location?.lng()
                        );
                      }}
                      defaultValue={isEdit?.pickup_address || ""}
                      error={errors?.pickup_address}
                    />
                  )}
                />
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Job Start Date & Time: (ETA){" "}
                    <span className="text-danger">*</span>
                  </Form.Label>
                  <Controller
                    name="job_start_datetime"
                    control={control}
                    defaultValue={isEdit?.job_start_datetime || ""}
                    rules={{
                      required: true,
                    }}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                        // onChange={(e) => field.onChange(moment(e.target.value)?.format('YYYY-MM-DD H:mm:ss'))}
                        type="datetime-local"
                        isInvalid={errors.job_start_datetime}
                      />
                    )}
                  />
                </Form.Group>
              </div>
              <div className="col-md-4 mb-3">
                <Form.Label>Additional Information:</Form.Label>

                <Form.Check
                  type="switch"
                  id="additional-info-toggle-pick"
                  // label="Additional Information"
                  checked={showAdditionalPick}
                  onChange={() => setShowAdditionalPick((prev) => !prev)}
                />
              </div>

              {/* Conditionally render fields */}
              {showAdditionalPick && (
                <>
                  <div className="col-md-4">
                    <Form.Group className="mb-3">
                      <Form.Label>Contact Person Phone (Optional)</Form.Label>
                      <Controller
                        name="pickup_person_phone"
                        control={control}
                        defaultValue={isEdit?.pickup_person_phone || ""}
                        rules={{ required: false }}
                        render={({ field }) => (
                          <div
                            className={`${
                              errors?.pickup_person_phone
                                ? "border border-danger"
                                : ""
                            }`}
                          >
                            <PhoneInput
                              {...field}
                              country={"us"}
                              inputProps={{
                                name: "pickup_person_phone",
                                required: true,
                                autoFocus: true,
                              }}
                            />
                          </div>
                        )}
                      />
                    </Form.Group>
                  </div>

                  <div className="col-md-4">
                    <Form.Group className="mb-3">
                      <Form.Label>Contact Person Name (Optional)</Form.Label>
                      <Controller
                        name="pickup_person_name"
                        control={control}
                        defaultValue={isEdit?.pickup_person_name || ""}
                        rules={{ required: false }}
                        render={({ field }) => (
                          <Form.Control
                            {...field}
                            type="text"
                            isInvalid={errors?.pickup_person_name}
                          />
                        )}
                      />
                    </Form.Group>
                  </div>
                </>
              )}
              {/* <div className="col-md-4">
                                <Form.Group className="mb-3">
                                    <Form.Label>Postal Code:</Form.Label>
                                    <Controller
                                        name="drop_postal_code"
                                        control={control}
                                        defaultValue={isEdit?.drop_postal_code || ''}
                                        rules={{
                                            required: false
                                        }}
                                        render={({ field }) => (
                                            <Form.Control
                                                {...field}
                                                type="text"
                                                isInvalid={errors.drop_postal_code}
                                            />
                                        )}
                                    />
                                </Form.Group>
                            </div> */}
            </div>

            {/*<div className='row justify-content-between my-3'>*/}
            {/*    <div className='col-auto'>*/}
            {/*        <h6 className='mb-0'>Pick Up Documents:</h6>*/}
            {/*    </div>*/}
            {/*    <div className="col-auto">*/}
            {/*        <Button type='button' aria-label="Delete" onClick={addPickUpRow}*/}
            {/*            className="btn btn-danger-light">*/}
            {/*            <i className="fa fa-plus" />*/}
            {/*        </Button>*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/*{pickupdoc?.filter(item => !('deleted_trip_docs' in item))?.map((doc, index) => (*/}
            {/*    <div key={index} className='row align-items-end mb-3'>*/}
            {/*        <div className="col-md">*/}
            {/*            {doc?.id}*/}
            {/*            <Form.Group className="">*/}
            {/*                <Form.Label>Document Type:</Form.Label>*/}

            {/*                <Controller*/}
            {/*                    name={`pickupdoc[${index}].type2`}*/}
            {/*                    control={control}*/}
            {/*                    defaultValue={doc?.document_name || ''}*/}
            {/*                    rules={{*/}
            {/*                        required: true*/}
            {/*                    }}*/}
            {/*                    render={({ field }) => (*/}
            {/*                        <Form.Select*/}
            {/*                            {...field}*/}
            {/*                            onChange={(e) => {*/}
            {/*                                field.onChange(e.target.value);*/}
            {/*                                setValue(`pickupdoc[${index}].type`, 'PICKUP')*/}
            {/*                                e.target.value != 'others' ? setValue(`pickupdoc[${index}].document_name`, e.target.value) : setValue(`pickupdoc[${index}].document_name`, '')*/}
            {/*                            }}*/}
            {/*                            isInvalid={errors?.pickupdoc?.[index]?.type2}*/}
            {/*                        >*/}
            {/*                            <option value="">Select Type</option>*/}
            {/*                            <option value="POL">POL</option>*/}
            {/*                            <option value="POD">POD</option>*/}
            {/*                            <option value="others">Others</option>*/}
            {/*                        </Form.Select>*/}
            {/*                    )}*/}
            {/*                />*/}
            {/*            </Form.Group>*/}
            {/*        </div>*/}
            {/*        <div className="col-md">*/}
            {/*            <Form.Group className="">*/}
            {/*                <Form.Label>Document Name:</Form.Label>*/}

            {/*                <Controller*/}
            {/*                    name={`pickupdoc[${index}].document_name`}*/}
            {/*                    control={control}*/}
            {/*                    defaultValue={doc?.document_name || ''}*/}
            {/*                    rules={{*/}
            {/*                        required: true*/}
            {/*                    }}*/}
            {/*                    render={({ field }) => (*/}
            {/*                        <Form.Control*/}
            {/*                            {...field}*/}
            {/*                            type="text"*/}
            {/*                            isInvalid={errors?.pickupdoc?.[index]?.document_name}*/}
            {/*                        />*/}
            {/*                    )}*/}
            {/*                />*/}
            {/*            </Form.Group>*/}
            {/*        </div>*/}
            {/*        <div className="col-md-auto">*/}
            {/*            <Button aria-label="Delete" onClick={() => removePickUpRow(doc)}*/}
            {/*                className="btn bg-red">*/}
            {/*                <i className="ri-delete-bin-7-line" />*/}
            {/*            </Button>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*))}*/}

            <br />
            <h5>Drop Off Details:</h5>

            <div className="row d-flex align-items-end">
              <div className="col-md-4">
                <Controller
                  name="drop_address"
                  control={control}
                  defaultValue={isEdit?.drop_address || ""}
                  rules={{
                    required: true,
                  }}
                  render={({ field }) => (
                    <DropOffLocation
                      onSave={(place) => {
                        setValue("drop_place_id", place?.place_id);
                        setValue("drop_address", place?.formatted_address);
                        setValue(
                          "drop_latitude",
                          place?.geometry?.location?.lat()
                        );
                        setValue(
                          "drop_longitude",
                          place?.geometry?.location?.lng()
                        );
                      }}
                      defaultValue={isEdit?.drop_address || ""}
                      error={errors.drop_address}
                    />
                  )}
                />
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Job End Date & Time: (ETD){" "}
                    <span className="text-danger">*</span>
                  </Form.Label>
                  <Controller
                    name="drop_datetime"
                    control={control}
                    defaultValue={isEdit?.drop_datetime || ""}
                    rules={{
                      required: true,
                    }}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                        // onChange={(e) => field.onChange(moment(e.target.value)?.format('YYYY-MM-DD H:mm:ss'))}
                        type="datetime-local"
                        isInvalid={errors.dropoff_datetime}
                      />
                    )}
                  />
                </Form.Group>
              </div>
              <div className="col-md-4 mb-3">
                <Form.Label>Additional Information:</Form.Label>
                <Form.Check
                  type="switch"
                  id="additional-info-toggle-drop"
                  // label="Additional Information"
                  checked={showAdditionalDrop}
                  onChange={() => setShowAdditionalDrop((prev) => !prev)}
                />
              </div>
              {showAdditionalDrop && (
                <>
                  <div className="col-md-4">
                    <Form.Group className="mb-3">
                      <Form.Label>Contact Person Phone (Optional)</Form.Label>
                      <Controller
                        name="drop_person_phone"
                        control={control}
                        defaultValue={isEdit?.drop_person_phone || ""}
                        rules={{
                          required: false,
                        }}
                        render={({ field }) => (
                          <div
                            className={`${
                              errors?.drop_person_phone
                                ? "border border-danger"
                                : ""
                            }`}
                          >
                            <PhoneInput
                              {...field}
                              country={"us"} // Default country
                              inputProps={{
                                name: "drop_person_phone",
                                required: true,
                                autoFocus: true,
                              }}
                            />
                          </div>
                        )}
                      />
                    </Form.Group>
                  </div>

                  <div className="col-md-4">
                    <Form.Group className="mb-3">
                      <Form.Label>Contact Person Name (Optional)</Form.Label>
                      <Controller
                        name="drop_person_name"
                        control={control}
                        defaultValue={isEdit?.drop_person_name || ""}
                        rules={{
                          required: false,
                        }}
                        render={({ field }) => (
                          <Form.Control
                            {...field}
                            type="text"
                            isInvalid={errors.drop_person_name}
                          />
                        )}
                      />
                    </Form.Group>
                  </div>
                </>
              )}
              {/*<div className="col-md-4">
                                <Form.Group className="mb-3">
                                    <Form.Label>Postal Code:</Form.Label>
                                    <Controller
                                        name="pickup_postal_code"
                                        control={control}
                                        defaultValue={isEdit?.pickup_postal_code || ''}
                                        rules={{
                                            required: false
                                        }}
                                        render={({ field }) => (
                                            <Form.Control
                                                {...field}
                                                type="text"
                                                isInvalid={errors.pickup_postal_code}
                                            />
                                        )}
                                    />
                                </Form.Group>
                            </div>*/}
            </div>
            {/*<div className='row justify-content-between my-3'>*/}
            {/*    <div className='col-auto'>*/}
            {/*        <h6 className='mb-0'>Drop Off Documents:</h6>*/}
            {/*    </div>*/}
            {/*    <div className="col-auto">*/}
            {/*        <Button type='button' onClick={addDropOffRow} aria-label="Delete"*/}
            {/*            className="btn btn-danger-light">*/}
            {/*            <i className="fa fa-plus" />*/}
            {/*        </Button>*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/*{dropoffdoc?.map((doc, index) => (*/}
            {/*    <div key={index} className='row align-items-end mb-3'>*/}
            {/*        <div className="col-md">*/}
            {/*            <Form.Group className="">*/}
            {/*                <Form.Label>Document Type:</Form.Label>*/}

            {/*                <Controller*/}
            {/*                    name={`dropoffdoc[${index}].type2`}*/}
            {/*                    control={control}*/}
            {/*                    defaultValue={doc?.document_name || ''}*/}
            {/*                    rules={{*/}
            {/*                        required: true*/}
            {/*                    }}*/}
            {/*                    render={({ field }) => (*/}
            {/*                        <Form.Select*/}
            {/*                            {...field}*/}
            {/*                            onChange={(e) => {*/}
            {/*                                field.onChange(e.target.value);*/}
            {/*                                setValue(`dropoffdoc[${index}].type`, 'DROPOFF')*/}
            {/*                                e.target.value != 'others' ? setValue(`dropoffdoc[${index}].document_name`, e.target.value) : setValue(`dropoffdoc[${index}].document_name`, '')*/}
            {/*                            }}*/}
            {/*                            isInvalid={errors?.dropoffdoc?.[index]?.type2}*/}
            {/*                        >*/}
            {/*                            <option value="">Select Type</option>*/}
            {/*                            <option value="POL">POL</option>*/}
            {/*                            <option value="POD">POD</option>*/}
            {/*                            <option value="others">Others</option>*/}
            {/*                        </Form.Select>*/}
            {/*                    )}*/}
            {/*                />*/}
            {/*            </Form.Group>*/}
            {/*        </div>*/}
            {/*        <div className="col-md">*/}
            {/*            <Form.Group className="">*/}
            {/*                <Form.Label>Document Name:</Form.Label>*/}

            {/*                <Controller*/}
            {/*                    name={`dropoffdoc[${index}].document_name`}*/}
            {/*                    control={control}*/}
            {/*                    defaultValue={doc?.document_name || ''}*/}
            {/*                    rules={{*/}
            {/*                        required: true*/}
            {/*                    }}*/}
            {/*                    render={({ field }) => (*/}
            {/*                        <Form.Control {...field} type="text"*/}
            {/*                            isInvalid={errors?.dropoffdoc?.[index]?.document_name} />*/}
            {/*                    )}*/}
            {/*                />*/}
            {/*            </Form.Group>*/}
            {/*        </div>*/}
            {/*        <div className="col-md-auto">*/}
            {/*            <Button aria-label="Delete" onClick={() => removeDropOffRow(doc)}*/}
            {/*                className="btn bg-red">*/}
            {/*                <i className="ri-delete-bin-7-line" />*/}
            {/*            </Button>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*))}*/}

            <hr className="pt-3" />
            <h5>Required Attachments:</h5>
            <div className="row">
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>Rate Confirmation Document:</Form.Label>
                  <Controller
                    name={"rate_confirmation_document"}
                    control={control}
                    defaultValue={""}
                    rules={{
                      required: false,
                    }}
                    render={({ field }) => (
                      <Form.Control
                        type="file"
                        onChange={(e) => field.onChange(e.target.files[0])}
                      />
                    )}
                  />
                  {isEdit?.rate_confirmation_document_url &&
                    isEdit?.rate_confirmation_document_url != undefined && (
                      <a
                        href={isEdit?.rate_confirmation_document_url || void 0}
                        className="mt-3 d-block"
                        target="_blank"
                      >
                        {
                          isEdit?.rate_confirmation_document_url?.split("/")?.[
                            isEdit?.rate_confirmation_document_url?.split("/")
                              ?.length - 1
                          ]
                        }
                      </a>
                    )}
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>Show Original Document:</Form.Label>

                  <Controller
                    name={"show_original_document"}
                    control={control}
                    defaultValue={isEdit?.show_original_document}
                    rules={{
                      required: false,
                    }}
                    render={({ field }) => (
                      <>
                        <div className="form-switch">
                          <input
                            {...field}
                            type="checkbox"
                            className="form-check-input"
                            defaultChecked={field.value}
                            checked={field.value}
                            onChange={(e) =>
                              field.onChange(e.target.checked ? 1 : 0)
                            }
                          />
                        </div>
                      </>
                    )}
                  />
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>Show Rate to Driver:</Form.Label>

                  <Controller
                    name={"show_rate_to_driver"}
                    control={control}
                    defaultValue={isEdit?.show_rate_to_driver}
                    rules={{
                      required: false,
                    }}
                    render={({ field }) => (
                      <>
                        <div className="form-switch">
                          <input
                            {...field}
                            type="checkbox"
                            className="form-check-input"
                            defaultChecked={field.value}
                            checked={field.value}
                            onChange={(e) =>
                              field.onChange(e.target.checked ? 1 : 0)
                            }
                          />
                        </div>
                      </>
                    )}
                  />
                </Form.Group>
              </div>
            </div>
            <hr />
            <h5>Job Detail:</h5>
            <div className="row">
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Job Amount <span className="text-danger">*</span>
                  </Form.Label>
                  <Controller
                    name={"job_amount"}
                    control={control}
                    defaultValue={isEdit?.job_amount || ""}
                    rules={{
                      required: true,
                    }}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                        type="number"
                        placeholder="Enter job amount"
                        isInvalid={errors?.job_amount}
                      />
                    )}
                  />
                </Form.Group>
              </div>
              {/* <div className="col-md-4">
                                <Form.Group className="mb-3">
                                    <Form.Label>Transit :</Form.Label>
                                    <Controller
                                        name={'transit'}
                                        control={control}
                                        defaultValue={isEdit?.transit || ''}
                                        rules={{
                                            required: false
                                        }}
                                        render={({ field }) => (
                                            <Form.Control {...field} type="text" isInvalid={errors?.transit} />
                                        )}
                                    />
                                </Form.Group>
                            </div> */}
              {/* <div className="col-md-4">
                                <Form.Group className="mb-3">
                                    <Form.Label className="text-capitalize">EMPTYREΡΟ :</Form.Label>
                                    <Controller
                                        name={'emptyrepo'}
                                        control={control}
                                        defaultValue={isEdit?.emptyrepo || ''}
                                        rules={{
                                            required: false
                                        }}
                                        render={({ field }) => (
                                            <Form.Control {...field} type="number" isInvalid={errors?.emptyrepo} />
                                        )}
                                    />
                                </Form.Group>
                            </div> */}
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label className="text-capitalize">
                    Estimated Miles{" "}
                  </Form.Label>
                  <Controller
                    name={"estimated_miles"}
                    control={control}
                    defaultValue={isEdit?.estimated_miles || ""}
                    rules={{
                      required: false,
                    }}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                        type="number"
                        isInvalid={errors?.estimated_miles}
                      />
                    )}
                  />
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label className="text-capitalize">
                    Estimated Dollar Per Mile :
                  </Form.Label>
                  <Controller
                    name={"estimated_dollar_per_mile"}
                    control={control}
                    defaultValue={isEdit?.estimated_dollar_per_mile || ""}
                    rules={{
                      required: false,
                    }}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                        type="number"
                        isInvalid={errors?.estimated_dollar_per_mile}
                        readOnly // make this read-only since it’s auto-calculated
                      />
                    )}
                  />
                </Form.Group>
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer className="">
          <LoadingButtonWithForm
            isLoading={editLoading ? editLoading : addLoading}
            name="Save"
            form="job-add-form"
          />
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddCompanyModal;
